import queries from '../graphql/queries';

export const isStandaloneDevice = (apollo) =>
{
	const clientPlatformResult = apollo.readQuery({query: queries.clientPlatform});
	const clientPlatform = clientPlatformResult.clientPlatform
	const isStandalone = clientPlatform ? (clientPlatform.PlatformType === "VR" && !clientPlatform.Capabilities?.includes("KBAM")) : false;

	return isStandalone;
}